import { useEffect } from "react";
import useVideoEventBus from "../useVideoEventBus";

const useSetupVideoEventListener = (
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  callback: (e: MouseEvent) => void = () => {},
) => {
  const { addVideoPlayerEventListener, removeVideoPlayerEventListener } =
    useVideoEventBus();

  useEffect(() => {
    addVideoPlayerEventListener(eventName, callback);
    return () => removeVideoPlayerEventListener(eventName, callback);
  }, [eventName, callback]);
};

export default useSetupVideoEventListener;
